import { usePullToRefresh } from '../hooks/usePullToRefresh'

export default function PullToRefresh({ onRefresh, children }) {
  const { pullDistance, refreshing } = usePullToRefresh(onRefresh)
  const showing = pullDistance > 0 || refreshing

  return (
    <>
      {showing && (
        <div
          className="pull-indicator"
          style={{ height: refreshing ? 48 : pullDistance, opacity: refreshing ? 1 : Math.min(pullDistance / 60, 1) }}
        >
          <div className={`pull-indicator__spinner${refreshing ? ' pull-indicator__spinner--active' : ''}`} />
        </div>
      )}
      {children}
    </>
  )
}
